var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSecurity({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 12.4425L8.5575 10.5L7.5 11.5575L10.5 14.5575L16.5 8.5575L15.4425 7.5L10.5 12.4425Z",
    fill: ""
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.5L7.36815 20.0303C6.0476 19.3278 4.94328 18.279 4.17372 16.9964C3.40415 15.7138 2.9984 14.2458 3 12.75V3C3.00042 2.6023 3.15859 2.22101 3.43981 1.9398C3.72102 1.65859 4.10231 1.50042 4.5 1.5H19.5C19.8977 1.50042 20.279 1.65859 20.5602 1.9398C20.8414 2.22101 20.9996 2.6023 21 3V12.75C21.0016 14.2458 20.5959 15.7138 19.8263 16.9964C19.0567 18.279 17.9524 19.3278 16.6319 20.0303L12 22.5ZM4.5 3V12.75C4.49871 13.9739 4.83072 15.175 5.46041 16.2244C6.0901 17.2738 6.9937 18.132 8.0742 18.7067L12 20.8L15.9258 18.7067C17.0063 18.132 17.9099 17.2738 18.5396 16.2244C19.1693 15.175 19.5013 13.9739 19.5 12.75V3H4.5Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSecurity);
export default __webpack_public_path__ + "static/media/ic-security.2aa1d4420360f6cc7898c0c17270157b.svg";
export { ForwardRef as ReactComponent };